import { createContext, useContext } from "react"
import { IpRight } from "./renewal_types"

// Importing of new IP Rights is done specicically for each actual payment provider as this is too complex to abstract
export const IpRightsContext = createContext({
    ipRights: [] as IpRight[],

    stopIpRight: (ipRight: IpRight) => Promise.resolve(),

    ipRightById: {} as Record<number, IpRight>,
    ipRightByFamilyMemberId: {} as Record<number, IpRight>,
})

export function useIpRights() {
    return useContext(IpRightsContext)
}